"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParseFloat = void 0;
function safeParseFloat(v, dValue = 0) {
    try {
        return parseFloat(v.toString() || dValue.toString());
    }
    catch (_a) {
        return dValue;
    }
}
exports.safeParseFloat = safeParseFloat;
exports.default = safeParseFloat;
